import { render, staticRenderFns } from "./AppFooterEmbed.vue?vue&type=template&id=9e86326c&scoped=true&"
import script from "./AppFooterEmbed.vue?vue&type=script&lang=js&"
export * from "./AppFooterEmbed.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterEmbed.vue?vue&type=style&index=0&id=9e86326c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e86326c",
  null
  
)

export default component.exports